<div *ngIf="data" class="main-create-edit-workflow overflow-scroll" cdkScrollable>

  <div class="header">
    <div class="gap--8 d-flex align-items-center">
      <h3>{{title}}</h3>
      <div *ngIf="edited" class="edited" (click)="editedTooltip.show()">
        <div>Edited</div>
        <app-icon src="question-mark-tooltip"
                  matTooltip="This item was changed from its original state in the item list"
                  [matTooltipShowDelay]="300"
                  matTooltipClass="header-tooltip"
                  class="scale--85"
                  #editedTooltip="matTooltip"
                  [hideTooltipOnScroll]="editedTooltip"
        ></app-icon>
      </div>
      <div *ngIf="notExisting" class="edited not-existing" (click)="warningTooltip.show()">
        <div>Warning!</div>
        <app-icon src="question-mark-tooltip"
                  matTooltip="Deleted from item list"
                  [matTooltipShowDelay]="300"
                  matTooltipClass="warning-tooltip"
                  class="scale--85"
                  #warningTooltip="matTooltip"
                  [hideTooltipOnScroll]="warningTooltip"
        ></app-icon>
      </div>
    </div>
    <app-icon class="se-icon-button" src="close" (click)="close()"></app-icon>
  </div>

  <div class="content">
    <form [formGroup]="form">
      <div class="d-flex flex-column" [class.error]="emptyNameError || usedNameError">
        <h5>Name</h5>
        <mat-form-field appearance="outline" class="textarea" appFormFieldFilled>
          <textarea #nameField
                    matInput cdkTextareaAutosize
                    cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"
                    formControlName="name" tabindex="1"
                    (click)="scrolledToTop = true"
                    [matAutocomplete]="autocomplete"
                    (focus)="focus$.next('name')"
                    (focusout)="focus$.next('unfocused')"
                    [anchorAutocompleteOnScroll]="trigger"
                    #trigger="matAutocompleteTrigger"
          ></textarea>
          <div *ngIf="emptyNameError" class="input-error textarea">Name is required</div>
          <div *ngIf="usedNameError" class="input-error textarea" [class.two-row-name]="nameFieldHeight > 30">
            Name already in use
          </div>
          <mat-autocomplete #autocomplete="matAutocomplete" (optionSelected)="nameSelected($event)">
            <mat-option *ngFor="let nameSuggestions of nameSuggestions$ | async" [value]="nameSuggestions.name">
              {{nameSuggestions.name + nameSuggestions.price}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="d-flex flex-column">
        <h5>Description</h5>
        <mat-form-field appearance="outline" class="textarea" appFormFieldFilled>
          <textarea matInput cdkTextareaAutosize
                    cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
                    formControlName="description"
                    tabindex="2"
                    #descriptionField
                    (click)="scrolledToTop = true"
                    (focus)="focus$.next('description')"
                    (focusout)="focus$.next('unfocused')"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="d-flex justify-content-center gap--10">
        <div class="d-flex flex-column" [class.error]="emptyPriceError">
          <h5>Price</h5>
          <mat-form-field appearance="outline" appFormFieldFilled class="item-equal-divide">
            <div class="d-flex">
              <div class="d-flex align-items-center mr--3">$</div>
              <input matInput
                     formControlName="price"
                     autocomplete="off"
                     tabindex="3"
                     class="fw-600"
                     (focus)="emptyPriceError=false; focus$.next('price')"
                     (focusout)="focus$.next('unfocused')"
                     inputmode="decimal"
                     mask="separator.2" thousandSeparator="" decimalMarker="."
                     [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                     (keyup)="decimalOnly($event)"
                     (paste)="onPaste($event)"
                     replaceCommaWithDot
              >
              <div *ngIf="emptyPriceError" class="input-error">Price is required</div>
            </div>
          </mat-form-field>
        </div>
        <div class="d-flex flex-column">
          <h5>Cost</h5>
          <mat-form-field appearance="outline" appFormFieldFilled class="item-equal-divide">
            <div class="d-flex">
              <div class="d-flex align-items-center mr--3">$</div>
              <input matInput
                     formControlName="cost"
                     autocomplete="off"
                     tabindex="4"
                     class="fw-600"
                     (focus)="focus$.next('cost')"
                     (focusout)="focus$.next('unfocused')"
                     inputmode="decimal"
                     mask="separator.2" thousandSeparator="" decimalMarker="."
                     (keydown)="tabHandle($event, 'cost', nameField); decimalOnly($event)"
                     (paste)="onPaste($event)"
                     [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                     replaceCommaWithDot
              >
            </div>
          </mat-form-field>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="discount-block d-flex gap--8 align-items-center w-100"
             *ngIf="form.get('price')?.value && form.get('price')?.value > 0"
        >
          <div style="color: #1B1B1B; white-space: nowrap;">Set Discount</div>
          <div class="d-flex align-items-center justify-content-between w-100">
            <div id="discountField" [class.error]="discountAboveAmount">
              <mat-form-field appearance="outline" appFormFieldFilled>
                <div class="d-flex" *ngIf="form.get('discountType')?.value === 'amount'">
                  <div class="d-flex align-items-center mr--2">$</div>
                  <input matInput
                        formControlName="discountAmount"
                        tabindex="5"
                        (focus)="focus$.next('discount')"
                        (focusout)="focus$.next('unfocused')"
                        inputmode="decimal"
                        mask="separator.2" thousandSeparator="" decimalMarker="."
                        [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                        (keydown)="tabHandle($event, 'discount', nameField); decimalOnly($event)"
                        (paste)="onPaste($event)"
                        replaceCommaWithDot
                  >
                  <div class="inputError" *ngIf="discountAboveAmount">Above item amount</div>
                </div>
                <div class="d-flex" *ngIf="form.get('discountType')?.value === 'percent'">
                  <input matInput class="tar"
                        formControlName="discountPercent"
                        tabindex="5"
                        (focus)="focus$.next('discount')"
                        (focusout)="focus$.next('unfocused')"
                        inputmode="decimal"
                        mask="separator.2" thousandSeparator="" decimalMarker="."
                        [allowNegativeNumbers]="false" [dropSpecialCharacters]="false"
                        (keydown)="tabHandle($event, 'discount', nameField); decimalOnly($event)"
                        (paste)="onPaste($event)"
                        replaceCommaWithDot
                  >
                  <div class="d-flex align-items-center ml--2" style="color: #1B1B1B;">%</div>
                  <div class="inputError" *ngIf="discountAboveAmount">Above item amount</div>
                </div>
                <div class="discount-divider"></div>
                <app-icon src="change" class="ml--4 clickable" (click)="toggleDiscountType()"></app-icon>
              </mat-form-field>
            </div>
            <div class="other-discount-value" [class.danger]="temporaryDiscountValue > +form.get('price')?.value"
              *ngIf="temporaryDiscountValue > 0 && form.get('discountType')?.value === 'percent'"
            >
              ${{(+temporaryDiscountValue).toFixed(2)}}
            </div>
            <div class="other-discount-value" [class.danger]="temporaryDiscountValue > 100"
              *ngIf="temporaryDiscountValue > 0 && form.get('discountType')?.value === 'amount'"
            >
              {{(+temporaryDiscountValue).toFixed(2)}}%
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="form.get('price')?.value && form.get('price')?.value > 0 && form.get('cost')?.value && form.get('cost')?.value > 0"
           class="markup" [class.negative]="+getMarkupValue() < 0"
      >
        Markup {{getMarkupValue()}}%
      </div>
      <div class="mt--20 d-flex align-items-center justify-content-between"
           *ngIf="form.get('price')?.value && form.get('price')?.value > 0"
      >
        <div class="gap--8 d-flex align-items-center">
          <div class="d-flex align-items-center gap--4" (click)="taxTooltip.show()">
            <div>Sales Tax</div>
            <app-icon src="question-mark-tooltip"
                      matTooltip="Estimates/Invoices are based on the customers zip code"
                      [matTooltipShowDelay]="300"
                      matTooltipClass="header-tooltip"
                      class="scale--85"
                      style="color: #65707C"
                      #taxTooltip="matTooltip"
                      [hideTooltipOnScroll]="taxTooltip"
            ></app-icon>
          </div>
          <div class="tax-select">
            <div
              (click)="form.get('taxable')?.setValue(false)"
              [class.not-selected]="form.get('taxable')?.value === false"
              class="tax-selector"
            >
              0%
            </div>
            <div
              (click)="form.get('taxable')?.setValue(true)"
              [class.selected]="form.get('taxable')?.value === true"
              class="tax-selector"
            >
              {{taxPercentage}}%
            </div>
          </div>
        </div>
        <div *ngIf="form.get('taxable')?.value === true" class="fw-600">${{getSalesTaxValue()}}</div>
      </div>
    </form>
    <div class="divider" *ngIf="form.get('price')?.value && form.get('price')?.value > 0"></div>
    <div class="d-flex justify-content-between fw-600"
         *ngIf="form.get('price')?.value && form.get('price')?.value > 0"
    >
      <div>Total</div>
      <div>${{getTotalValue()}}</div>
    </div>


    <div class="button-wrap" *ngIf="modalState$ | async let modalState">
      <ng-container *ngIf="checkDiscount()">
        <loader-button class="flex-fill" [loading]="loading1" [text]="'Add only here'"
                       (onClick)="addOnlyHere()" *ngIf="modalState.includes('addOnlyHere')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <loader-button class="flex-fill" [loading]="loading2" [text]="'Add here & Create in Item list'"
                       (onClick)="addHereAndToTheItemList()"
                       *ngIf="modalState.includes('addHereAndToTheItemList')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <loader-button class="flex-fill" [loading]="loading2" [text]="'Add here & Update Item list'"
                       (onClick)="addHereAndUpdateInTheItemList()"
                       *ngIf="modalState.includes('addHereAndUpdateInTheItemList')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <div class="flat-outline-btn-wrapper"
             *ngIf="modalState.includes('updateInTheItemList')"
             [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        >
          <div class="flat-outline-btn"
               (click)="updateInTheItemList()"
          >
            Update in Item list
          </div>
        </div>
        <div class="flat-outline-btn-wrapper"
             *ngIf="modalState.includes('createInTheItemList')"
             [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        >
          <div class="flat-outline-btn"
               (click)="createInTheItemList()"
          >
            Create in Item list
          </div>
        </div>
        <loader-button class="flex-fill" [loading]="loading1" [text]="'Update'"
                       (onClick)="update()" *ngIf="modalState.includes('update')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <loader-button class="flex-fill" [loading]="loading1" [text]="'Update only here'"
                       (onClick)="updateOnlyHere()" *ngIf="modalState.includes('updateOnlyHere')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <loader-button class="flex-fill" [loading]="loading2" [text]="'Update here & Item list'"
                       (onClick)="updateHereAndInTheItemList()"
                       *ngIf="modalState.includes('updateHereAndInTheItemList')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <loader-button class="flex-fill" [loading]="loading2" [text]="'Update here & Create in Item list'"
                       (onClick)="updateHereAndCreateInTheItemList()"
                       *ngIf="modalState.includes('updateHereAndCreateInTheItemList')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
        <loader-button class="flex-fill" [loading]="loading1" [text]="'Add'"
                       (onClick)="addOnlyHere()" *ngIf="modalState.includes('add')"
                       [@fadeIn]="{ value: ':leave', params : { time: '250ms' } }"
        ></loader-button>
      </ng-container>
      <button mat-stroked-button (click)="close()">Close</button>
    </div>
  </div>

</div>
